import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

export const zoomFinishOAuth = makeSubmitData<{ uid: string; code: string }>(
	"zoomFinishOAuth"
);
